import MenuApiInteractor from '@package/core/src/menu/MenuApiInteractor';
import MenuApiService from '@package/core/src/menu/MenuApiService';

import { apiClient } from '../services';
import { useStrictQuery } from '../useCustomQuery';

import { MENU_QUERY_KEY } from './types';
import { useRouter } from 'next/router';

const menuApiService = new MenuApiService(apiClient);
const menuInteractor = new MenuApiInteractor(menuApiService);

const useMenu = () => {
  const router = useRouter();
  const { data: menuData } = useStrictQuery(
    [MENU_QUERY_KEY],
    async () => {
      const res = await menuInteractor.getMenuData();
      return res;
    },
    {
      enabled: !router.pathname.includes('/checkout'),
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      // staleTime: 30 * (60 * 1000), // 30 mins
      // cacheTime: 35 * (60 * 1000),
    },
  );

  return { menuData };
};

export default useMenu;
